const Navigation = {};
Navigation.BACK = "NavEvent.BACK";
Navigation.OK = "NavEvent.OK";

export default Navigation;